<template lang="pug">
  el-card.box-card(shadow="always")
    .clearfix(slot='header')
      span Προσθήκη
      span(v-if="['Admin', 'RegistryAdmin'].includes(activeRole)") /Τροποποίηση
      span : Πανεπιστημίου/Κολλεγίου/Σχολής/Τμήματος
      el-button(style='float: right; padding: 5px 5px; margin: 10px 10px;', type='text',
        v-show='addUniversity'  @click="hideForm") Κλείσιμο
    .text.item
      el-alert(
        title="ΠΡΟΣΟΧΗ! Για τη διαχείριση των Νέων Πανεπιστημίων μεταβείτε στην αντίστοιχη επιλογή του μενού"
        type="error"
        :closable="false"
        show-icon
      )
      el-form(:inline='true', :inline-message="true", label-width='130px', size='small', v-loading="deletingUnit")
        el-form-item(label="Λειτουργία", v-if="['Admin', 'RegistryAdmin'].includes(activeRole)")
          el-switch(v-model="addOrModify" active-text="Προσθήκη" inactive-text="Τροποποίηση"
            @change='addOrModifyChanged')
        br(v-show='!addOrModify')
        el-form-item(label="Τροποποίηση σε", v-show='!addOrModify', v-if="['Admin', 'RegistryAdmin'].includes(activeRole)")
          el-checkbox-group(v-model="checkboxΙnstitutions" @change='groupChanged')
            el-checkbox-button(v-for="institution in institutions" :label="institution" :key="institution") {{institution}}
        // Meetings
        el-form-item(label='Προσθήκη Συνεδρίας', prop='meeting', v-show='addOrModify', v-if="['Admin', 'RegistryAdmin'].includes(activeRole)")
          el-checkbox(v-model='addMeeting', @change='addMeetingChanged')
        br
        el-form-item(label='Αρ. Συνεδρίας', prop="meeting", v-loading='gettingMeetings'
          v-show="!addOrModify && checkboxΙnstitutions[0] === 'Συνεδρία'")
            el-select.big(v-model='meeting' , value-key="id", placeholder='Όνομα Συνεδρίας',
              filterable, clearable, @change='meetingSelected')
              el-option(v-for="meeting in meetings", :key="meeting.id",
                :label="meeting.meeting_no", :value="meeting")
        el-card.box-card(shadow="always", v-loading='gettingMeeting',
          v-show="addMeeting || (!addOrModify && checkboxΙnstitutions[0] === 'Συνεδρία')")
          .clearfix(slot='header')
            span(v-if='addOrModify') Εισάγετε νέα Συνεδρία
            span(v-else) Επιλέξτε και Τροποποιήστε την Συνεδρία {{meeting.meeting_no}}
          .text.item(v-loading='savingMeeting')
            el-form-item(label='Αρ. Συνεδρίας*', prop="meeting.meeting_no")
              el-input.big(type="text", placeholder='Συνεδρία', v-model='meeting.nameInserted',
              @input="meeting.nameInserted = meeting.nameInserted.toUpperCase()")
            el-form-item(label='Ημερομηνία Συνεδρίας*', prop="meeting.meeting_date")
              el-date-picker(v-model="meeting.meeting_date", type="date", placeholder="Ημερομηνία Συνεδρίας",
                format="dd-MM-yyyy", value-format="dd-MM-yyyy")
            el-form-item(label='Τύπος Συνεδρίας*', prop="meeting.ds_epitropi")
              el-select.big(v-model='meeting.ds_epitropi', value-key="id", placeholder='Τύπος Συνεδρίας',
                filterable, clearable)
                el-option(v-for="epi in dsEpitropes", :key="epi.key", :label="epi.label",
                  :value="epi.value")
            el-form-item(label='Αρμοδιότητα*', prop="meeting.resp_id")
              el-select.big(v-model='meeting.resp_id', value-key="id", placeholder='Αρμοδιότητα',
                filterable, clearable)
                el-option(v-for="resp in respId", :key="resp.key", :label="resp.label",
                  :value="resp.value")
        // Country Management
        el-form-item(label='Χώρα', v-loading="gettingCountries", prop="country", v-show="showAll.country && !addMeeting")
          el-select.countries(
            v-model='country',
            @change="countrySelected",
            @focus='getCountries'
            value-key="id",
            placeholder='Χώρα',
            filterable, clearable)
            el-option(v-for="country in countries",
              :key="country.id",
              :label="country.name",
              :value="country")
            el-option(v-show='addOrModify && activeRole !== "RegistryAdmin"', :label='otherValue.name', :value='otherValue', :key="otherValue.name")
        el-card.box-card(shadow="always", v-loading='savingCountry || gettingCountry',
          v-show="(country.name === 'Άλλο'|| (!addOrModify && checkboxΙnstitutions[0] === 'Χώρα')) && !addMeeting")
          .clearfix(slot='header')
            span(v-if='addOrModify') Εισάγετε νέα Χώρα
            span(v-else) Επιλέξτε και Τροποποιήστε την Χώρα {{country.name}}
          .text.item(v-show="showAll.country && !isEmptyValue(country.name)")
            el-form-item(label='Όνομα*'  prop="country.nameInserted")
              el-input.big(placeholder='Όνομα*', v-model='country.nameInserted',
                @input="country.nameInserted = country.nameInserted.toUpperCase()",
                @change="countryInsertedChanged")
            //- el-form-item(label='Νέο Όνομα*'  prop="country.nameInserted")
            //-   el-input.big(type="text", placeholder='Όνομα Χώρας',
            //-     v-model='country.nameInserted', @change="countryInsertedChanged",
            //-     @input="country.nameInserted = country.nameInserted.toUpperCase()")
            el-form-item(label='Συντομογραφία', prop='country.short_name')
              el-input(placeholder='Συντομογραφία', v-model='country.short_name',
                @input="country.short_name = country.short_name.toUpperCase()")
            el-tooltip(placement='right')
              div(slot='content')
                | Μέχρι 4 χαρακτήρες με βάση αυτό: https://www.nationsonline.org/oneworld/country_code_list.htm
              i.el-icon-question
            el-form-item(label='Προηγ. Όνομα', prop='country.ex_name')
              el-input(placeholder='Προηγούμενο Όνομα', v-model='country.ex_name',
                @input="country.ex_name = country.ex_name.toUpperCase()")
            el-form-item(label='Έχει πολιτείες', prop='states_exist')
              el-checkbox(v-model='states_exist' @change="statesExistsChanged")
            hr(v-show='!addOrModify')
            // City Management
            el-form-item(label="Διαχείριση Πόλεων", v-show='!addOrModify')
              el-switch(v-model="manageCities", active-text="Ναι",inactive-text="Όχι", @change='manageCitiesChanged')
              el-form-item(label='Επιλέξτε Πόλη', v-show='manageCities', v-loading='gettingCities')
                el-select.big(v-model='city' , @change="cityForCountrySelected", value-key="id", placeholder='Πόλεις',
                  filterable, clearable)
                  el-option(v-for="city in citiesForCountry", :key="city.id", :label="city.name", :value="city")
                  el-option(label='Άλλο', value='other', key="other")
              el-card.box-card(shadow="always",
                v-show='manageCities && (!isEmptyValue(city.name) || city === "other")', v-loading='gettingCity')
                .clearfix(slot='header')
                  span() {{addModifyTextCity}} {{city.name}} της χώρας {{country.name}}
                .text.item(v-loading='savingCity')
                  el-form-item(label='Όνομα', prop='city.nameInserted')
                    el-input(placeholder='Όνομα', v-model='city.nameInserted',
                      @input="city.nameInserted = city.nameInserted.toUpperCase()")
                  // Dropdown for selecting state for city if it belongs to one
                  el-form-item(label='Πολιτεία που ανήκει', v-loading='gettingStates', v-if='city.state && country.states_exist === 1')
                    el-select(v-model='city.state', value-key="id", placeholder='Πολιτείες', filterable, clearable)
                      el-option(v-for="state in statesForCities", :key="state.id", :label="state.name", :value="state")
                  div(style='text-align: center')
                    el-button(type="primary" @click="saveNewCity" icon="el-icon-edit") Αποθήκευση Πόλης
                    el-button(type="danger" @click="deleteCity" icon="el-icon-delete") Διαγραφή Πόλης
            // States Management
            el-form-item(label="Διαχείριση Πολιτειών", v-show='!addOrModify && country.states_exist === 1')
              el-switch(v-model="manageStates", active-text="Ναι", inactive-text="Όχι", @change='manageStatesChanged')
              el-form-item(label='Επιλέξτε Πολιτεία', v-show='manageStates', v-loading='gettingStates')
                el-select.big(v-model='state' , @change="stateSelected", value-key="id", placeholder='Πολιτείες',
                  filterable, clearable)
                  el-option(v-for="state in states", :key="state.id", :label="state.name", :value="state")
                  el-option(label='Άλλο', value='other', key="other")
              el-card.box-card(shadow="always",
                v-show='manageStates && (!isEmptyValue(state.name) || state === "other")', v-loading='gettingState')
                .clearfix(slot='header')
                  span() {{addModifyTextState}} {{state.name}} της χώρας {{country.name}}
                .text.item(v-loading='savingState')
                  el-form-item(label='Όνομα', prop='state.nameInserted')
                    el-input(placeholder='Όνομα', v-model='state.nameInserted',
                      @input="state.nameInserted = state.nameInserted.toUpperCase()")
                  el-form-item(label='Συντομογραφία', prop='state.abbrv')
                    el-input(placeholder='Όνομα', v-model='state.abbrv',
                      @input="state.abbrv = state.abbrv.toUpperCase()")
                  div(style='text-align: center')
                    el-button(type="primary" @click="saveNewState" icon="el-icon-edit") Αποθήκευση Πολιτείας
                    el-button(type="danger" @click="deleteState" icon="el-icon-delete") Διαγραφή Πολιτείας
        // University Management
        br
        el-form-item(label='Πανεπιστήμιο', v-loading="gettingUniversities",
          prop="universitySelect", v-show='showAll.university && !addMeeting')
          el-select.big(v-model='universitySelect' , @change="universitySelected", value-key="id",
            placeholder='Πανεπιστήμια', :disabled="disableUniversity", filterable, clearable)
            el-option(v-for="university in universities", :key="university.id",
              :label="university.name", :value="university")
            el-option(v-show='addOrModify' label='Άλλο', value='other', key="other")
        el-card.box-card(shadow="always", v-loading='gettingUniversity',
          v-show="(university.name === 'other'|| (!addOrModify && checkboxΙnstitutions[0] === 'Πανεπιστήμιο')) && !addMeeting")
          .clearfix(slot='header')
            span(v-if='addOrModify') Εισάγετε νέο Πανεπιστήμιο για την χώρα {{country.name}}
            span(v-else) Επιλέξτε και Τροποποιήστε το Πανεπιστήμιο {{university.name}} της χώρας {{country.name}}
          .text.item(v-show="showAll.university && !isEmptyValue(university.name)")
            el-form-item(label='Όνομα*'  prop="university.nameInserted" v-if='addOrModify')
              el-input.big(type="text", placeholder='Όνομα',
                v-model='university.nameInserted',
                @change="universityInsertedChanged",
                @input="university.nameInserted = university.nameInserted.toUpperCase()")
            el-form-item(label='Νέο Όνομα*'  prop="university.nameInserted" v-else)
              el-input.big(type="text", placeholder='Όνομα',
                v-model='university.nameInserted',
                @change="universityInsertedChanged",
                @input="university.nameInserted = university.nameInserted.toUpperCase()")
                 //- ex_names: ''
            el-form-item(label='Προηγ. Όνομα1', prop='university.ex_name')
              el-input(placeholder='ex_name', v-model='university.ex_name',
                @input="university.ex_name = university.ex_name.toUpperCase()")
            el-form-item(label='Προηγ. Όνομα2', prop='university.ex_name1')
              el-input(placeholder='ex_name1', v-model='university.ex_name1',
                @input="university.ex_name1 = university.ex_name1.toUpperCase()")
                //- university_type_status: '',
            el-form-item(label='Παν/μιο?', prop='university.university_type_status')
              el-select(v-model='university.university_type_status', placeholder='Τύπος',
                filterable, clearable)
                el-option(label='Ναι', value='Y', key="Y")
                el-option(label='Άλλο Ίδρυμα', value='N', key="N")
                el-option(label='Επιτροπή', value='E', key="E")
                //- accredited: 'U', //R - accredited, N - not accredited, U - Under consideration
            el-form-item(label='Αναγνώριση*', prop="university.accredited")
              el-select(v-model='university.accredited', placeholder='Κατάσταση', filterable, clearable)
                el-option(label='Αναγνωρισμένο', value='R', key="R")
                el-option(label='Μη αναγνωρισμένο', value='N', key="N")
                el-option(label='Μη κριθέν', value='U', key="U")
                //- meetings_id: '',
            el-form-item(label='Αρ. Συνεδρίας', prop='university.meeting')
              el-select.big(v-model='university.meeting' , value-key="id", placeholder='Αριθμός Συνεδρίας', filterable)
                el-option(v-for="meeting in meetings", :key="meeting.id",
                  :label="meeting.meeting_no", :value="meeting")
                //- epitropi_id: '',
            el-form-item(label='Αρ. Πράξης', prop='university.epitropi_id')
              el-input(placeholder='epitropi_id', v-model='university.epitropi_id',
                @input="university.epitropi_id = university.epitropi_id.toUpperCase()")
                //- type: '',
            //- active: '',
            el-form-item(label='Ενεργό*', prop="college.active")
              el-select(v-model='college.active', placeholder='Ενεργό', filterable, clearable)
                el-option(label='Ναι', value='Y', key="Y")
                el-option(label='Όχι', value='N', key="N")
            el-form-item(label='Τύπος', prop='university.type')
              el-select(v-model='university.type', placeholder='Τύπος', filterable, clearable)
                el-option(label='', value='', key="N")
                el-option(label='Κρατικό', value='S', key="S")
                el-option(label='Ιδιωτικό', value='P', key="P")
            el-form-item(label='Διεύθυνση', prop='university.address')
              el-input(placeholder='Διεύθυνση', v-model='university.address',
                @input="university.address = university.address.toUpperCase()")
            el-form-item(label='Πόλη', v-loading="gettingCities", prop="university.city")
              el-select(v-model='university.city', placeholder='Πόλη', :disabled="disableCities",
                @change='citySelected', value-key="id", filterable, clearable)
                el-option(v-for="cit in cities", :key="cit.id", :label="cit.name", :value="cit")
            el-form-item(label='Πολιτεία', prop='university.states')
              el-select(v-model='university.states', placeholder='Πολιτεία', :disabled="disableUniState",
                @change='uniStateSelected', value-key="id", filterable, clearable)
                el-option(v-for="state in states", :key="state.id", :label="state.name", :value="state")
            el-form-item(label='Τηλέφωνο1', prop='university.phone')
              el-input(placeholder='Αριθμός', v-model='university.phone')
            el-form-item(label='Τηλέφωνο2', prop='university.other_phone')
              el-input(placeholder='Αριθμός άλλος', v-model='university.other_phone')
            el-form-item(label='Αριθμός fax', prop='university.fax_no')
              el-input(placeholder='Αριθμός fax', v-model='university.fax_no')
            el-form-item(label='Email', prop='university.email')
              el-input(placeholder='email', v-model='university.email')
                //- non_universities_type_id: '',
            el-form-item(label='Μη Παν/κό Ίδρυμα', prop='university.non_universities_type_id')
              el-input(placeholder='non_universities_type_id', v-model='university.non_universities_type_id',
                @input="university.non_universities_type_id = university.non_universities_type_id.toUpperCase()")
                //- h_internet: '',
            el-form-item(label='Για Διαδίκτυο', prop='university.h_internet')
              el-input.commentText(type="textarea", placeholder='h_internet', v-model='university.h_internet',
                class="commentText", @input="university.h_internet = university.h_internet.toUpperCase()")
                //- comments: '',
            el-form-item(label="Σχόλια:")
              el-input(type="textarea", class="commentText", placeholder="Εισάγετε εσωτερικό σχόλιο"
                v-model="university.comments" size="100" :autosize="{ minRows: 4, maxRows: 10 }")
        br
        el-form-item(label='Κολλέγιο', prop="collegeSelect", v-show='showAll.college && !addMeeting && activeRole !== "RegistryAdmin"')
          el-select.big(v-model='collegeSelect' , @change="collegeSelected", value-key="id",
            placeholder='Κολλέγια', :disabled="disableCollege", filterable, clearable)
            el-option(v-for="college in colleges", :key="college.id",
              :label="college.name", :value="college")
            el-option(v-if='showNotCollege' label='Οι σπουδές δεν έγιναν σε κολλέγιο',
              value='Οι σπουδές δεν έγιναν σε κολλέγιο', key="not")
            el-option(v-show='addOrModify' label='Άλλο', value='other', key="other")
        //- nameInserted: '',
        el-card.box-card(shadow="always", v-loading="gettingCollege",
          v-show="(college.name === 'other' || (!addOrModify && checkboxΙnstitutions[0] === 'Κολλέγιο')) && !addMeeting")
          .clearfix(slot='header')
            span(v-if='addOrModify') Εισάγετε νέο Κολλέγιο για το Πανεπιστήμιο {{university.nameInserted}}
            span(v-else) Τροποποιήστε το Κολλέγιο {{college.name}} του Πανεπιστημίου {{university.name}}
          .text.item(v-show="showAll.college && !isEmptyValue(college.name)")
            el-form-item(label='Όνομα*'  prop="college.nameInserted")
              el-input.big(type="text", placeholder='Συμπληρώστε το νέο Κολλέγιο',
                v-model='college.nameInserted',
                @input="college.nameInserted = college.nameInserted.toUpperCase()")
            // απαραιτητα να υπαρχουν – μπορούν να έχουν τιμή null
            //- accredited: 'U', //R - accredited, N - not accredited, U - Under consideration
            el-form-item(label='Αναγνώριση*', prop="college.accredited")
              el-select(v-model='college.accredited', placeholder='Κατάσταση', filterable, clearable)
                el-option(label='Αναγνωρισμένο', value='R', key="R")
                el-option(label='Μη αναγνωρισμένο', value='N', key="N")
                el-option(label='Μη κριθέν', value='U', key="U")
            //- meetings_id: '',
            el-form-item(label='Αρ. Συνεδρίας', prop='college.meeting')
              el-select.big(v-model='college.meeting' , value-key="id", placeholder='Αριθμός Συνεδρίας', filterable)
                el-option(v-for="meeting in meetings", :key="meeting.id",
                  :label="meeting.meeting_no", :value="meeting")
            // μπορει να μην υπαρχουν καν σαν πεδια
            //- epitropi_id: ''
            el-form-item(label='Αρ.Πράξης', prop='college.epitropi_id')
              el-input(placeholder='epitropi_id', v-model='college.epitropi_id',
                @input="college.epitropi_id = college.epitropi_id.toUpperCase()")
            //- comments: '',
            el-form-item(label="Σχόλια:")
              el-input(type="textarea" class="commentText" placeholder="Εισάγετε εσωτερικό σχόλιο"
                v-model="college.comments" size="100" :autosize="{ minRows: 4, maxRows: 10 }")
        br
        el-form-item(label='Σχολή', prop="facultySelect", v-show='showAll.faculty && !addMeeting && activeRole !== "RegistryAdmin"')
          el-select.big(v-model='facultySelect' , @change="facultySelected", value-key="id",
            placeholder='Σχολές', :disabled="disableFaculty", filterable, clearable)
            el-option(v-for="faculty in activeFaculties", :key="faculty.id",
              :label="faculty.name", :value="faculty")
            el-option(v-show='showNotFaculty' label='Οι σπουδές δεν έγιναν σε σχολή',
              value='Οι σπουδές δεν έγιναν σε σχολή', key="not")
            el-option(v-show='addOrModify' label='Άλλο', value='other', key="other")
        el-card.box-card(shadow="always", v-loading="gettingFaculty",
          v-show="(faculty.name === 'other' || (!addOrModify && checkboxΙnstitutions[0] === 'Σχολή')) && !addMeeting")
          .clearfix(slot='header')
            span(v-if='addOrModify') Εισάγετε νέα Σχολή για το Κολλέγιο {{college.nameInserted}}
            span(v-else) Τροποποιήστε την Σχολή {{faculty.name}} του Κολλεγγίου {{college.name}}
          .text.item(v-show="showAll.faculty && !isEmptyValue(faculty.name)")
            el-form-item(label='Όνομα*'  prop="faculty.nameInserted")
              el-input.big(type="text", placeholder='Όνομα Σχολής',
                v-model='faculty.nameInserted',
                @input="faculty.nameInserted = faculty.nameInserted.toUpperCase()")
            // απαραιτητα να υπαρχουν – μπορούν να έχουν τιμή null
            //- active: '',
            el-form-item(label='Ενεργό*', prop="faculty.active")
              el-select(v-model='faculty.active', placeholder='Ενεργό', filterable, clearable)
                el-option(label='Ναι', value='Y', key="Y")
                el-option(label='Όχι', value='N', key="N")
            //- accredited: 'U', //R - accredited, N - not accredited, U - Under consideration
            el-form-item(label='Αναγνώριση*', prop="faculty.accredited")
              el-select(v-model='faculty.accredited', placeholder='Κατάσταση', filterable, clearable)
                el-option(label='Αναγνωρισμένο', value='R', key="R")
                el-option(label='Μη αναγνωρισμένο', value='N', key="N")
                el-option(label='Μη κριθέν', value='U', key="U")
            //- meetings_id: '',
            el-form-item(label='Αρ. Συνεδρίας', prop='faculty.meeting')
              el-select.big(v-model='faculty.meeting' , value-key="id", placeholder='Αριθμός Συνεδρίας', filterable)
                el-option(v-for="meeting in meetings", :key="meeting.id", :label="meeting.meeting_no", :value="meeting")
            // μπορει να μην υπαρχουν καν σαν πεδια
            //- epitropi_id: ''
            el-form-item(label='Αρ. Πράξης', prop='faculty.epitropi_id')
              el-input(placeholder='epitropi_id', v-model='faculty.epitropi_id',
                @input="faculty.epitropi_id = faculty.epitropi_id.toUpperCase()")
            //- comments: '',
            el-form-item(label="Σχόλια:")
              el-input(type="textarea" class="commentText" placeholder="Εισάγετε εσωτερικό σχόλιο"
                v-model="faculty.comments" size="100" :autosize="{ minRows: 4, maxRows: 10 }")
        br
        el-form-item(label='Τμήμα', prop="departmentSelect", v-show='showAll.department && !addMeeting && activeRole !== "RegistryAdmin"')
          el-select.big(v-model='departmentSelect' , @change="departmentSelected", value-key="id",
            placeholder='Τμήματα Επιλεγμένης Σχολής', :disabled="disableDepartment", filterable, clearable)
            el-option(v-for="department in activeDepartments", :key="department.id",
              :label="department.name", :value="department")
            el-option(v-show='showNotDepartment' label='Οι σπουδές δεν έγιναν σε τμήμα',
              value='Οι σπουδές δεν έγιναν σε τμήμα', key="not")
            el-option(v-show='addOrModify' label='Άλλο', value='other', key="other")
        el-card.box-card(shadow="always", v-loading="gettingDepartment",
          v-show="(department.name === 'other' || (!addOrModify && checkboxΙnstitutions[0] === 'Τμήμα')) && !addMeeting")
          .clearfix(slot='header')
            span(v-if='addOrModify') Εισάγετε νέο Τμήμα για την Σχολή {{faculty.nameInserted}}
            span(v-else) Τροποποιήστε το Τμήμα {{department.name}} της Σχολής {{faculty.name}}
          .text.item(v-show="showAll.department && !isEmptyValue(department.name)")
            el-form-item(label='Όνομα*'  prop="department.nameInserted")
              el-input.big(type="text", placeholder='Όνομα Τμήματος',
                v-model='department.nameInserted',
                @input="department.nameInserted = department.nameInserted.toUpperCase()")
            // απαραιτητα να υπαρχουν – μπορούν να έχουν τιμή null
            //- active: '',
            el-form-item(label='Ενεργό*', prop="department.active")
              el-select(v-model='department.active', placeholder='Ενεργό', filterable, clearable)
                el-option(label='Ναι', value='Y', key="Y")
                el-option(label='Όχι', value='N', key="N")
            //- programme
            el-form-item(label='Πρόγραμμα*', prop='department.programme')
              //- el-input(placeholder='programme', v-model='department.programme')
              el-select(v-model='department.programme', placeholder='Πρόγραμμα/Σχολή', filterable, clearable)
                el-option(label='Πρόγραμμα', value='P', key="P")
                el-option(label='Σχολή', value='D', key="D")
            //- accredited: 'U', //R - accredited, N - not accredited, U - Under consideration
            el-form-item(label='Αναγνώριση*', prop="department.accredited")
              el-select(v-model='department.accredited', placeholder='Κατάσταση', filterable, clearable)
                el-option(label='Αναγνωρισμένο', value='R', key="R")
                el-option(label='Μη αναγνωρισμένο', value='N', key="N")
                el-option(label='Μη κριθέν', value='U', key="U")
            //- meetings_id: '',
            el-form-item(label='Αρ. Συνεδρίας', prop='department.meeting')
              el-select.big(v-model='department.meeting' , value-key="id", placeholder='Αριθμός Συνεδρίας', filterable)
                el-option(v-for="meeting in meetings", :key="meeting.id", :label="meeting.meeting_no", :value="meeting")
            // μπορει να μην υπαρχουν καν σαν πεδια
            //- epitropi_id: ''
            el-form-item(label='Αρ. Πράξης', prop='department.epitropi_id')
              el-input(placeholder='epitropi_id', v-model='department.epitropi_id',
                @input="department.epitropi_id = department.epitropi_id.toUpperCase()")
            //- academic_areas_id
            el-form-item(label='Ακαδ. Περιοχή', prop="department.academic_areas_id")
              el-select(v-model='department.academic_areas_id' , placeholder='Ακαδημαική Περιοχή',
                filterable, clearable)
                el-option(v-for="area in academicAreas", :key="area.id",
                  :label="area.name", :value="area.id")
                  | {{area.name}}
            //- comments: '',
            el-form-item(label="Σχόλια:")
              el-input(type="textarea" class="commentText" placeholder="Εισάγετε εσωτερικό σχόλιο"
                v-model="department.comments" size="100" :autosize="{ minRows: 4, maxRows: 10 }")
        div(style='text-align: center')
          el-button(type="primary" @click="saveNewUni" icon="el-icon-edit" :disabled='disableSave') {{saveButtonText}}
          el-button(type="danger" @click="deleteUni" icon="el-icon-delete" :disabled='disableDelete') Διαγραφή {{checkboxΙnstitutions[0]}}
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import axios from 'axios'
import config from '../../config.js'
import sharedMethods from '../common/sharedMethods.js'

export default {
  name: 'ManageDb',
  props: {
    addUniversity: {type: Boolean, default: false}
  },
  mixins: [sharedMethods],
  mounted () {
    // this.getCountries()
    this.getMeetings()
  },
  data () {
    return {
      dsEpitropes: [
        // { label: 'Επιτροπή', value: 'E', key: 'E' },
        { label: 'Διοικητικό', value: 'D', key: 'D' }
      ],
      respId: [
        { label: 'Γραμματεία Τμήμα Α', value: 107, key: 107 },
        { label: 'Γραμματεία Τμήμα B', value: 114, key: 114 }
      ],
      statesForCities: [],
      // meetings: [],
      addMeeting: false,
      meeting: {meeting_no: '', id: '', nameInserted: '', meeting_date: '', ds_epitropi: 'D', resp_id: ''},
      savingState: false,
      savingCity: false,
      savingMeeting: false,
      addModifyTextCity: 'Τροποποιήστε την Πόλη',
      addModifyTextState: 'Τροποποιήστε την Πολιτεία',
      manageCities: false,
      manageStates: false,
      states_exist: false,
      departmentSelect: {name: '', id: null},
      facultySelect: {name: '', id: null},
      collegeSelect: {name: '', id: null},
      universitySelect: {name: '', id: null},
      otherValue: {id: null, name: 'Άλλο', nameInserted: '', ex_name: '', states_exist: 0, short_name: ''},
      checkboxΙnstitutions: [''],
      // institutions: ['Χώρα', 'Πανεπιστήμιο', 'Κολλέγιο', 'Σχολή', 'Τμήμα', 'Συνεδρία'],
      addOrModify: true,
      application: {},
      state: {
        id: null,
        name: '',
        nameInserted: '',
        countries_id: null,
        abbrv: null
      },
      country: {
        id: '',
        name: '',
        nameInserted: '',
        ex_name: '',
        states_exist: 0,
        short_name: ''
      },
      states: [],
      university: {
        // απαραιτητα να υπαρχουν – μπορούν να έχουν τιμή null
        id: '', // null for new university
        name: '',
        nameInserted: '',
        countries_id: '',
        cities_id: '',
        city: {id: '', name: ''}, // city_id
        active: 'Y', // Y - Yes or N - No
        accredited: 'U', // R - accredited, N - not accredited, U - Under consideration
        meetings_id: null,
        // μπορει να μην υπαρχουν καν σαν πεδια
        comments: '',
        fax_no: '',
        other_phone: '',
        email: '',
        university_type_status: '',
        states: '',
        epitropi_id: '',
        address: '',
        phone: '',
        non_universities_type_id: '',
        h_internet: '',
        type: '',
        ex_name: '',
        ex_name1: ''
      },
      college: {
        id: '',
        name: '',
        nameInserted: '',
        // απαραιτητα να υπαρχουν – μπορούν να έχουν τιμή null
        active: 'Y',
        meetings_id: 0,
        accredited: 'U',
        // μπορει να μην υπαρχουν καν σαν πεδια
        comments: '',
        epitropi_id: ''
      },
      faculty: {
        id: '',
        name: '',
        nameInserted: '',
        // απαραιτητα να υπαρχουν – μπορούν να έχουν τιμή null
        active: 'Y',
        meetings_id: null,
        accredited: 'U',
        // μπορει να μην υπαρχουν καν σαν πεδια
        comments: '',
        epitropi_id: ''
      },
      department: {
        id: '',
        name: '',
        nameInserted: '',
        // απαραιτητα να υπαρχουν – μπορούν να έχουν τιμή null
        programme: 'Πρόγραμμα',
        active: 'Y',
        meetings_id: null,
        accredited: 'U',
        // μπορει να μην υπαρχουν καν σαν πεδια
        comments: '',
        academic_areas_id: '',
        epitropi_id: ''
      },
      deletingCity: false,
      deletingState: false,
      deletingUnit: false,
      gettingCity: false,
      gettingState: false,
      gettingStates: false,
      gettingCountry: false,
      savingCountry: false,
      gettingCollege: false,
      gettingUniversities: false,
      gettingDepartment: false,
      gettingUniversity: false,
      gettingFaculty: false,
      gettingCities: false,
      gettingMeetings: false,
      gettingMeeting: false,
      collegeDepartment: {id: '', name: ''},
      collegeFaculty: {id: '', name: ''},
      colFacDept: {},
      disableCities: false,
      disableUniversity: true,
      disableCollege: true,
      disableDepartment: true,
      disableFaculty: true,
      disableUniState: false,
      // countries: [],
      cities: [],
      citiesForCountry: [],
      city: {id: null, name: '', nameInserted: '', state: {name: '', id: ''}},
      universities: [],
      colleges: [],
      collegeFaculties: [],
      activeFaculties: [],
      activeDepartments: [],
      colFacDepartments: [],
      faculties: [],
      departments: [],
      disableSave: false,
      showAll: {country: true, university: true, college: true, faculty: true, department: true}
    }
  },
  methods: {
    // capitalize (value) {
    //   if (!value) return ''
    //   return value.toUpperCase()
    // },
    statesExistsChanged () {
      this.country.states_exist = this.states_exist ? 1 : 0
    },
    addMeetingChanged (val) {
      if (val) {
        this.showAll = {country: false, university: false, college: false, faculty: false, department: false}
      } else {
        this.showAll = {country: true, university: true, college: true, faculty: true, department: true}
      }
    },
    uniStateSelected (state) {
    },
    meetingSelected () {
      this.getMeeting()
    },
    cityForCountrySelected (val) {
      if (val !== 'other') {
        this.gettingCity = true
        this.addModifyTextCity = 'Τροποποιήστε την Πόλη'
        axios.get(`${config.BASE_URL}/admins/userId/countries/${this.country.id}/cities/${val.id}`)
          .then((response) => {
            this.city = response.data.data
            this.$set(this.city, 'nameInserted', response.data.data.name)
            this.gettingCity = false
            // if (!this.isEmptyValue(this.city.state.id)) {
            //   this.city.state = this.getStates()
            // }
          }).catch(err => {
            this.gettingCity = false
            this.backendError(err)
          })
      } else {
        this.addModifyTextCity = 'Εισάγετε νέα Πόλη'
        this.city = {name: 'other', nameInserted: '', state: {name: '', id: null}}
      }
    },
    getMeetings () {
      this.gettingMeetings = true
      axios.get(`${config.BASE_URL}/meetings`)
        .then((response) => {
          this.$store.dispatch('LOAD_MEETINGS', response.data.data)
          // this.meetings = response.data.data // .slice(1, 50)
          this.meetings.unshift({id: null, meeting_no: ''})
          this.gettingMeetings = false
        }).catch(err => {
          this.gettingMeetings = false
          this.backendError(err)
        })
    },
    getMeeting () {
      this.gettingMeeting = true
      axios.get(`${config.BASE_URL}/meetings/${this.meeting.id}`)
        .then((response) => {
          this.meeting = response.data.data
          this.meeting.nameInserted = this.meeting.meeting_no
          this.gettingMeeting = false
        }).catch(err => {
          this.gettingMeeting = false
          this.backendError(err)
        })
    },
    getState (id) {
      return axios.get(`${config.BASE_URL}/admins/userId/countries/${this.country.id}/states/${id}`)
        .then((response) => {
          this.state = response.data.data
          this.$set(this.state, 'nameInserted', response.data.data.name)
          this.gettingState = false
        }).catch(err => {
          this.gettingState = false
          this.backendError(err)
        })
    },
    getStates () {
      this.gettingStates = true
      return axios.get(`${config.BASE_URL}/admins/userId/countries/${this.country.id}/states`)
        .then((response) => {
          this.states = response.data.data
          this.gettingStates = false
          return response
        }).catch(err => {
          this.gettingStates = false
          this.backendError(err)
          throw err
        })
    },
    stateSelected (val) {
      if (val !== 'other') {
        this.gettingState = true
        this.addModifyTextState = 'Τροποποιήστε την Πολιτεία'
        axios.get(`${config.BASE_URL}/admins/userId/countries/${this.country.id}/states/${val.id}`)
          .then((response) => {
            this.state = response.data.data
            this.$set(this.state, 'nameInserted', response.data.data.name)
            this.gettingState = false
          }).catch(err => {
            this.gettingState = false
            this.backendError(err)
          })
      } else {
        this.addModifyTextState = 'Εισάγετε νέα Πολιτεία'
        this.state = {name: 'other', nameInserted: '', abbrv: ''}
      }
    },
    getCities () {
      this.gettingCities = true
      return axios.get(`${config.BASE_URL}/countries/${this.country.id}/cities`)
        .then((response) => {
          this.gettingCities = false
          return response
        }).catch(err => {
          this.gettingCities = false
          this.backendError(err)
          throw err
        })
    },
    manageCitiesChanged (manage) {
      if (manage) {
        this.getCities().then((response) => {
          this.citiesForCountry = response.data.data
          this.gettingCities = false
        }).catch(err => {
          this.citiesForCountry = []
          this.gettingCities = false
          console.log(err)
        })
        if (this.country.states_exist === 1) {
          this.getStates().then((response) => {
            this.statesForCities = response.data.data
            this.gettingStates = false
          }).catch(err => {
            this.statesForCities = []
            this.gettingStates = false
            console.log(err)
          })
        }
      }
    },
    manageStatesChanged () {
      this.getStates().then((response) => {
        this.states = response.data.data
        this.gettingStates = false
      })
    },
    getCountries () {
      this.$store.dispatch('LOAD_COUNTRIES')
    },
    hideForm () {
      this.initializeUniversity()
      this.initializeCollege()
      this.initializeFaculty()
      this.initializeDepartment()
      this.$emit('hideForm')
    },
    initializeDepartment () {
      Object.keys(this.department).forEach(key => { this.department[key] = '' })
      this.department.name = ''
      this.department.id = null
      delete this.department.meeting
      this.department.accredited = 'U'
      this.department.active = 'Y'
      this.department.meetings_id = null
      this.department.programme = 'P'
      this.department.id = null
      this.departmentSelect = {id: null, name: ''}
    },
    initializeCollege () {
      Object.keys(this.college).forEach(key => { this.college[key] = '' })
      this.college.name = ''
      this.college.id = null
      delete this.college.meeting
      this.college.accredited = 'U'
      this.college.active = 'Y'
      this.college.meetings_id = null
      this.college.id = null
      this.collegeSelect = {id: null, name: ''}
    },
    initializeFaculty () {
      Object.keys(this.faculty).forEach(key => { this.faculty[key] = '' })
      this.faculty.name = ''
      this.faculty.id = null
      delete this.faculty.meeting
      this.faculty.accredited = 'U'
      this.faculty.active = 'Y'
      this.faculty.meetings_id = null
      this.faculty.id = null
      this.facultySelect = {id: null, name: ''}
    },
    initializeUniversity () {
      Object.keys(this.university).forEach(key => { this.university[key] = '' })
      this.university.countries_id = this.country.id
      this.university.cities_id = null
      delete this.university.meeting
      delete this.university.greek_countries_id
      delete this.university.states_id
      this.university.id = null
      this.universitySelect = {name: '', id: null}
      this.university.accredited = 'U'
      this.university.active = 'Y'
    },
    groupChanged (data) {
      this.addMeeting = false
      this.manageStates = false
      this.state = { id: null, name: '', countries_id: null, abbrv: null }
      this.manageCities = false
      this.city = { id: null, name: '', state: {name: '', id: ''} }
      this.country = {id: '', name: '', nameInserted: '', ex_name: '', states_exist: 0, short_name: ''}
      this.departmentSelect = {name: '', id: null}
      this.department.name = ''
      this.department.id = null
      this.facultySelect = {name: '', id: null}
      this.faculty.name = ''
      this.faculty.id = null
      this.collegeSelect = {name: '', id: null}
      this.college.name = ''
      this.college.id = null
      this.universitySelect = {name: '', id: null}
      this.university.name = ''
      this.university.id = null
      let temp = this.checkboxΙnstitutions[this.checkboxΙnstitutions.length - 1]
      this.checkboxΙnstitutions = []
      this.checkboxΙnstitutions.push(temp)
      switch (this.checkboxΙnstitutions[0]) {
        case 'Χώρα':
          this.showAll = {country: true, university: false, college: false, faculty: false, department: false}
          break
        case 'Πανεπιστήμιο':
          this.showAll = {country: true, university: true, college: false, faculty: false, department: false}
          break
        case 'Κολλέγιο':
          this.showAll = {country: true, university: true, college: true, faculty: false, department: false}
          break
        case 'Σχολή':
          this.showAll = {country: true, university: true, college: true, faculty: true, department: false}
          break
        case 'Τμήμα':
          this.$store.dispatch('LOAD_ACADEMIC_AREAS')
          this.showAll = {country: true, university: true, college: true, faculty: true, department: true}
          break
        case 'Συνεδρία':
          this.showAll = {country: false, university: false, college: false, faculty: false, department: false}
          this.addMeeting = true
          break
      }
    },
    // el-option(label='Αναγνωρισμένο', value='R', key="R")
    //             el-option(label='Μη αναγνωρισμένο', value='N', key="N")
    //             el-option(label='Μη κριθέν', value='U', key="U")
    calcAccreditedValue (val) {
      switch (val) {
        case 'R':
          return 'Αναγνωρισμένο'
        case 'N':
          return 'Μη αναγνωρισμένο'
        case 'U':
          return 'Μη κριθέν'
      }
    },
    calcActiveValue (val) {
      return val ? 'Ναι' : 'Όχι'
    },
    addConfirmMessage () {
      let missingRequired = false
      let message = `Στην χώρα: ${this.country.name} ${this.addOrModify ? ' θα προσθέσετε ' : ' θα τροποποιήσετε '}`
      if (this.university.name === 'other' || (!this.addOrModify && this.checkboxΙnstitutions[0] === 'Πανεπιστήμιο')) {
        if (this.university.nameInserted === '' || this.university.city.name === '' ||
        this.university.active === '' || this.university.accredited === '') { // || this.university.meeting.meeting_no === ''
          missingRequired = true
          message = ''
          message = 'Παρακαλώ συμπληρώστε σωστά όλα τα πεδία με αστερίσκο για το Πανεπιστήμιο. '
        } else {
          missingRequired = false
          message += 'το Πανεπιστήμιο: ' + this.university.nameInserted + ',' +
          ' που είναι στην πόλη: ' + this.university.city.name + ',' +
          ' που είναι ενεργό: ' + this.calcActiveValue(this.university.active) + ',' +
          ' και αναγνωρισμένο: ' + this.calcAccreditedValue(this.university.accredited) + ',' +
          ' με αριθμό συνεδρίας: ' +
          (this.university.meeting && !this.isEmptyValue(this.university.meeting.id) ? this.university.meeting.meeting_no : '--') + ','
        }
      } else {
        message += 'στο υπάρχον Πανεπιστήμιο: ' + this.university.name + ','
      }
      if (!missingRequired) {
        if (this.college.name === 'other' || (!this.addOrModify && this.checkboxΙnstitutions[0] === 'Κολλέγιο')) {
          if (this.college.nameInserted === '' ||
          this.college.active === '' || this.college.accredited === '') {
            missingRequired = true
            message = ''
            message = 'Παρακαλώ συμπληρώστε σωστά όλα τα πεδία με αστερίσκο για το Κολλέγιο'
          } else {
            missingRequired = false
            message += ' το Κολλέγιο: ' + this.college.nameInserted + ',' +
          ' που είναι ενεργό: ' + this.calcActiveValue(this.college.active) + ',' +
          ' και αναγνωρισμένο: ' + this.calcAccreditedValue(this.college.accredited) + ',' +
          ' με αριθμό συνεδρίας: ' +
          (this.college.meeting && !this.isEmptyValue(this.college.meeting.id) ? this.college.meeting.meeting_no : '--') + ','
          }
        } else {
          if (!this.isEmptyValue(this.college.name)) { message += ' στο υπάρχον Κολλέγιο: ' + this.college.name + ',' }
        }
      }
      if (!missingRequired) {
        if (this.faculty.name === 'other' || (!this.addOrModify && this.checkboxΙnstitutions[0] === 'Σχολή')) {
          if (this.isEmptyValue(this.faculty.nameInserted) || this.isEmptyValue(this.faculty.active) ||
            this.isEmptyValue(this.faculty.accredited)) {
            missingRequired = true
            message = ''
            message = 'Παρακαλώ συμπληρώστε σωστά όλα τα πεδία με αστερίσκο για την Σχολή'
          } else {
            missingRequired = false
            message += ' την Σχολή: ' + this.faculty.nameInserted + ',' +
          ' που είναι ενεργή: ' + this.calcActiveValue(this.faculty.active) + ',' +
          ' και αναγνωρισμένη: ' + this.calcAccreditedValue(this.faculty.accredited) + ',' +
          ' με αριθμό συνεδρίας: ' +
          (this.faculty.meeting && !this.isEmptyValue(this.faculty.meeting.id) ? this.faculty.meeting.meeting_no : '--') + ','
          }
        } else {
          if (!this.isEmptyValue(this.faculty.name)) { message += ' στην υπάρχουσα Σχολή: ' + this.faculty.name + ',' }
        }
      }
      if (!missingRequired) {
        if (this.department.name === 'other' || (!this.addOrModify && this.checkboxΙnstitutions[0] === 'Τμήμα')) {
          if (this.department.nameInserted === '' ||
          this.department.active === '' || this.department.accredited === '' ||
          this.department.programme === '') {
            missingRequired = true
            message = ''
            message = 'Παρακαλώ συμπληρώστε σωστά όλα τα πεδία με αστερίσκο για το Τμήμα'
          } else {
            missingRequired = false
            message += ' Το Τμήμα: ' + this.department.nameInserted + ',' +
          ' που είναι ενεργό: ' + this.calcActiveValue(this.department.active) + ',' +
          ' και αναγνωρισμένο: ' + this.calcAccreditedValue(this.department.accredited) + ',' +
          ' με αριθμό συνεδρίας: ' +
          (this.department.meeting && !this.isEmptyValue(this.department.meeting.id) ? this.department.meeting.meeting_no : '--') +
          ' και με πρόγραμμα: ' + this.department.programme + '.'
          }
        } else {
          if (!this.isEmptyValue(this.department.name)) { message += ' στο υπάρχον Τμήμα: ' + this.department.name + '.' }
        }
      }
      return {message: message, missingRequired: missingRequired}
    },
    deleteState () {
      this.deletingState = true
      this.$confirm(`Προσοχή! Θα διαγράψετε την Πολιτεία ${this.state.name} αν δεν έχει πόλεις`, 'Προειδοποίηση', {
        confirmButtonText: 'Διαγραφή',
        cancelButtonText: 'Άκυρο',
        type: 'warning'
      }).then(() => {
        axios.delete(`${config.BASE_URL}/admins/userId/countries/${this.country.id}/states/${this.state.id}`)
          .then((response) => {
            this.notifyUser('success', 'Επιτυχία', 'Η διαγραφή ολοκληρώθηκε επιτυχώς')
            this.deletingState = false
          }).catch((err) => {
            this.deletingState = false
            this.notifyUser('error', 'Αποτυχία', 'Παρουσιάστηκε σφάλμα κατά την διαγραφή')
            this.backendError(err)
          })
      }).catch((err) => {
        console.log(err)
        this.$message({
          type: 'info',
          message: 'Η διαγραφή ματαιώθηκε'
        })
      })
    },
    deleteCity () {
      this.deletingCity = true
      this.$confirm(`Προσοχή! Θα διαγράψετε την Πόλη ${this.city.name} αν δεν έχει Πανεπιστήμια`, 'Προειδοποίηση', {
        confirmButtonText: 'Διαγραφή',
        cancelButtonText: 'Άκυρο',
        type: 'warning'
      }).then(() => {
        axios.delete(`${config.BASE_URL}/admins/userId/countries/${this.country.id}/cities/${this.city.id}`)
          .then((response) => {
            this.notifyUser('success', 'Επιτυχία', 'Η διαγραφή ολοκληρώθηκε επιτυχώς')
            this.deletingCity = false
            this.city = { id: null, name: '', state: {name: '', id: ''} }
            this.getCities().then((response) => {
              this.citiesForCountry = response.data.data
              this.gettingCities = false
            })
          }).catch((err) => {
            this.deletingCity = false
            this.notifyUser('error', 'Αποτυχία', 'Παρουσιάστηκε σφάλμα κατά την διαγραφή')
            this.backendError(err)
          })
      }).catch((err) => {
        console.log(err)
        this.$message({
          type: 'info',
          message: 'Η διαγραφή ματαιώθηκε'
        })
      })
    },
    deleteUni () {
      if ((this.college.name === 'Οι σπουδές δεν έγιναν σε κολλέγιο' && this.checkboxΙnstitutions[0] === 'Κολλέγιο') ||
        (this.faculty.name === 'Οι σπουδές δεν έγιναν σε σχολή' && this.checkboxΙnstitutions[0] === 'Σχολή') ||
        (this.department.name === 'Οι σπουδές δεν έγιναν σε τμήμα' && this.checkboxΙnstitutions[0] === 'Τμήμα')) {
        this.$notify.warning({
          title: 'Προειδοποίηση',
          message: 'Δεν μπορείτε να διαγράψετε αυτήν την επιλογή',
          offset: 300
        })
      } else {
        let deleteUnitId = null
        let deleteUrl = ''
        let confirmMessage = `ΠΡΟΣΟΧΗ! Θα διαγράψετε `
        let cannotDelete = false
        switch (this.checkboxΙnstitutions[0]) {
          case 'Χώρα':
            if (!this.isEmptyValue(this.country.id)) {
              deleteUnitId = this.country.id
              deleteUrl = 'countries'
              confirmMessage += `την Χώρα ${this.country.name}`
            } else {
              cannotDelete = true
            }
            break
          case 'Πανεπιστήμιο':
            if (!this.isEmptyValue(this.university.id)) {
              deleteUnitId = this.university.id
              deleteUrl = 'uni'
              confirmMessage += `το Πανεπιστήμιο ${this.university.name}`
            } else {
              cannotDelete = true
            }
            break
          case 'Κολλέγιο':
            if (!this.isEmptyValue(this.college.id)) {
              deleteUnitId = this.college.id
              deleteUrl = 'col'
              confirmMessage += `το Κολλέγιο ${this.college.name}`
            } else {
              cannotDelete = true
            }
            break
          case 'Σχολή':
            if (!this.isEmptyValue(this.faculty.id)) {
              deleteUnitId = this.faculty.id
              deleteUrl = 'fac'
              confirmMessage += `την Σχολή ${this.faculty.name}`
            } else {
              cannotDelete = true
            }
            break
          case 'Τμήμα':
            if (!this.isEmptyValue(this.department.id)) {
              deleteUnitId = this.department.id
              deleteUrl = 'dep'
              confirmMessage += `το Τμήμα ${this.department.name}`
            } else {
              cannotDelete = true
            }
            break
          case 'Συνεδρία':
            if (!this.isEmptyValue(this.meeting.id)) {
              deleteUnitId = this.meeting.id
              deleteUrl = 'meetings'
              confirmMessage += `την συνεδρία ${this.meeting.meeting_no}`
            } else {
              cannotDelete = true
            }
            break
        }
        confirmMessage += `. Η διαγραφή θα γίνει μόνο αν δεν υπάρχει σύνδεση με υπάρχουσες πράξεις!`
        if (!cannotDelete) {
          this.$confirm(confirmMessage, 'Προειδοποίηση', {
            confirmButtonText: 'Διαγραφή',
            cancelButtonText: 'Άκυρο',
            type: 'warning'
          }).then(() => {
            // DELETE /admins/{userId}/uni/{id}
            this.deletingUnit = true
            axios.delete(`${this.BASE_URL}/admins/userId/${deleteUrl}/${deleteUnitId}`)
              .then((response) => {
                this.notifyUser('success', 'Επιτυχία', 'Η διαγραφή ολοκληρώθηκε επιτυχώς')
                this.deletingUnit = false
                if (deleteUrl === 'meetings') {
                  this.meeting = {meeting_no: '', id: '', nameInserted: '', meeting_date: '', ds_epitropi: 'D', resp_id: ''}
                  this.getMeetings()
                }
                if (deleteUrl === 'countries') { this.getCountries() }
                this.initializeUniversity()
                this.initializeCollege()
                this.initializeFaculty()
                this.initializeDepartment()
                this.countryInsertedChanged()
                this.country = {id: '', name: '', nameInserted: '', ex_name: '', states_exist: 0, short_name: ''}
                this.collegeSelect = {id: null, name: ''}
                this.facultySelect = {id: null, name: ''}
                this.departmentSelect = {id: null, name: ''}
                this.disableFaculty = true
                this.disableDepartment = true
                this.disableCollege = true
                this.disableUniversity = true
              }).catch((err) => {
                this.deletingUnit = false
                this.notifyUser('error', 'Αποτυχία', 'Παρουσιάστηκε σφάλμα κατά την διαγραφή')
                this.backendError(err)
              })
          }).catch((err) => {
            console.log(err)
            this.$message({
              type: 'info',
              message: 'Η διαγραφή ματαιώθηκε'
            })
          })
        } else {
          this.notifyUser('error', 'Αποτυχία', 'Δεν έχετε επιλέξει τη δομή προς διαγραφή')
        }
      }
    },
    saveNewCity () {
      if (this.city.name !== 'other') {
        this.$confirm(`Θα αποθηκεύσετε τις αλλαγές στην Πόλη ${this.city.name}`, 'Προειδοποίηση', {
          confirmButtonText: 'Αποθήκευση',
          cancelButtonText: 'Άκυρο',
          type: 'warning'
        }).then(() => {
          this.savingCity = true
          axios.put(`${config.BASE_URL}/admins/userId/countries/${this.country.id}/cities/${this.city.id}`,
            {
              city: {
                name: this.city.nameInserted,
                state: this.country.states_exist === 1 && !this.isEmptyValue(this.city.state.id)
                  ? this.city.state
                  : null
              }
            }
          ).then((response) => {
            this.notifyUser('success', 'Επιτυχία', 'Η αποθήκευση ολοκληρώθηκε επιτυχώς')
            this.savingCity = false
            this.getCities().then((response) => {
              this.citiesForCountry = response.data.data
              this.gettingCities = false
            })
          }).catch((err) => {
            this.savingCity = false
            this.notifyUser('error', 'Αποτυχία', 'Παρουσιάστηκε σφάλμα κατά την αποθήκευση')
            this.backendError(err)
          })
        }).catch((err) => {
          console.log(err)
          this.$message({
            type: 'info',
            message: 'Η αποθήκευση ματαιώθηκε'
          })
        })
      } else {
        this.$confirm(`Θα εισάγετε την Πόλη ${this.city.nameInserted}`, 'Προειδοποίηση', {
          confirmButtonText: 'Αποθήκευση',
          cancelButtonText: 'Άκυρο',
          type: 'warning'
        }).then(() => {
          this.savingCity = true
          axios.post(`${config.BASE_URL}/admins/userId/countries/${this.country.id}/cities`,
            {
              city: {
                name: this.city.nameInserted,
                state: this.country.states_exist === 1 && !this.isEmptyValue(this.city.state.id)
                  ? {name: this.city.state.name, id: this.city.state.id}
                  : null
              }
            }
          ).then((response) => {
            this.notifyUser('success', 'Επιτυχία', 'Η εισαγωγή ολοκληρώθηκε επιτυχώς')
            this.savingCity = false
            this.getCities().then(response => { this.citiesForCountry = response.data.data })
          }).catch((err) => {
            this.savingCity = false
            this.notifyUser('error', 'Αποτυχία', 'Παρουσιάστηκε σφάλμα κατά την εισαγωγή')
            this.backendError(err)
          })
        }).catch((err) => {
          console.log(err)
          this.$message({
            type: 'info',
            message: 'Η εισαγωγή ματαιώθηκε'
          })
        })
      }
    },
    saveNewState () {
      if (this.state.name !== 'other') {
        this.$confirm(`Θα αποθηκεύσετε τις αλλαγές στην Πολιτεία ${this.state.name}`, 'Προειδοποίηση', {
          confirmButtonText: 'Αποθήκευση',
          cancelButtonText: 'Άκυρο',
          type: 'warning'
        }).then(() => {
          this.savingState = true
          axios.put(`${config.BASE_URL}/admins/userId/countries/${this.country.id}/states/${this.state.id}`,
            {
              state: {
                name: this.state.nameInserted,
                abbrv: this.state.abbrv
              }
            }
          ).then((response) => {
            this.notifyUser('success', 'Επιτυχία', 'Η αποθήκευση ολοκληρώθηκε επιτυχώς')
            this.getStates().then((response) => {
              this.states = response.data.data
              this.savingState = false
            })
          }).catch((err) => {
            this.savingState = false
            this.notifyUser('error', 'Αποτυχία', 'Παρουσιάστηκε σφάλμα κατά την αποθήκευση')
            this.backendError(err)
          })
        }).catch((err) => {
          console.log(err)
          this.$message({
            type: 'info',
            message: 'Η αποθήκευση ματαιώθηκε'
          })
        })
      } else {
        this.savingState = true
        this.$confirm(`Θα εισάγετε την Πολιτεία ${this.state.nameInserted}`, 'Προειδοποίηση', {
          confirmButtonText: 'Αποθήκευση',
          cancelButtonText: 'Άκυρο',
          type: 'warning'
        }).then(() => {
          axios.post(`${config.BASE_URL}/admins/userId/countries/${this.country.id}/states`,
            {
              state: {
                name: this.state.nameInserted,
                abbrv: this.state.abbrv
              }
            }
          ).then((response) => {
            this.notifyUser('success', 'Επιτυχία', 'Η εισαγωγή ολοκληρώθηκε επιτυχώς')
            this.savingState = false
          }).catch((err) => {
            this.savingState = false
            this.notifyUser('error', 'Αποτυχία', 'Παρουσιάστηκε σφάλμα κατά την εισαγωγή')
            this.backendError(err)
          })
        }).catch((err) => {
          console.log(err)
          this.$message({
            type: 'info',
            message: 'Η εισαγωγή ματαιώθηκε'
          })
        })
      }
    },
    saveNewUni () {
      let confirmMessage = {}
      if (this.addOrModify) {
        if (this.addMeeting) {
          this.savingMeeting = true
          axios.post(`${this.BASE_URL}/admins/userId/meetings`,
            {
              meeting: {
                meeting_no: this.meeting.nameInserted,
                meeting_date: this.meeting.meeting_date,
                ds_epitropi: this.meeting.ds_epitropi,
                resp_id: this.meeting.resp_id
              }
            }
          ).then((response) => {
            this.notifyUser('success', 'Επιτυχία', 'Η αποθήκευση ολοκληρώθηκε επιτυχώς')
            this.savingMeeting = false
            this.getMeetings()
            this.meeting = {meeting_no: '', id: '', nameInserted: '', meeting_date: '', ds_epitropi: 'D', resp_id: ''}
          }).catch((err) => {
            this.notifyUser('error', 'Αποτυχία', 'Παρουσιάστηκε σφάλμα κατά την αποθήκευση')
            this.savingMeeting = false
            this.backendError(err)
          })
        } else if (this.country.name === 'Άλλο') {
          // POST to add new country
          let tempCountry = {...this.country}
          tempCountry.name = tempCountry.nameInserted
          tempCountry.states_exist = this.states_exist ? 1 : 0
          delete tempCountry.id
          delete tempCountry.nameInserted
          axios.post(`${this.BASE_URL}/admins/userId/countries`,
            {
              country: tempCountry
            }
          ).then((response) => {
            this.notifyUser('success', 'Επιτυχία', 'Η αποθήκευση ολοκληρώθηκε επιτυχώς')
            // Object.keys(this.country).forEach(key => { this.country[key] = '' })
            this.getCountries()
          }).catch((err) => {
            this.notifyUser('error', 'Αποτυχία', 'Παρουσιάστηκε σφάλμα κατά την αποθήκευση')
            this.backendError(err)
          })
        } else if (this.university.name === null || this.college.name === null ||
        this.faculty.name === null || this.department.name === null) {
          this.$notify.warning({
            title: 'Προειδοποίηση',
            message: 'Παρακαλώ συμπληρώστε όλα τα πεδία Πανεπιστήμιο/Κολλέγιο/Σχολή/Τμήμα. Αν δεν γνωρίζετε επιλέξτε "Οι σπουδές δεν έγιναν σε..."',
            offset: 300
          })
        } else {
          confirmMessage = this.addConfirmMessage()
          this.$confirm(confirmMessage.message, 'Προειδοποίηση', {
            confirmButtonText: 'Αποθήκευση',
            cancelButtonText: 'Άκυρο',
            type: 'warning'
          }).then(() => {
            if (!confirmMessage.missingRequired) {
              let uni = {...this.university}
              let col = {...this.college}
              let fac = {...this.faculty}
              let dep = {...this.department}
              if (uni.name === 'other') {
                uni.name = uni.nameInserted
                if (uni.meeting) {
                  uni.meetings_id = uni.meeting.id
                  delete uni.meeting
                }
              }
              if (col.name === 'other') {
                col.name = col.nameInserted
                if (col.meeting) {
                  col.meetings_id = col.meeting.id
                  delete col.meeting
                }
              }
              if (fac.name === 'other') {
                fac.name = fac.nameInserted
                if (fac.meeting) {
                  fac.meetings_id = fac.meeting.id
                  delete fac.meeting
                }
              }
              if (dep.name === 'other') {
                dep.name = dep.nameInserted
                if (dep.meeting) {
                  dep.meetings_id = dep.meeting.id
                  delete dep.meeting
                }
              }
              if (uni.state) {
                uni.states = uni.state.id
              }
              delete uni.state
              delete uni.nameInserted
              if (uni.city) {
                uni.cities_id = uni.city.id
              } else {
                uni.cities_id = ''
              }
              delete uni.city
              delete col.nameInserted
              delete dep.nameInserted
              delete dep.id
              delete fac.nameInserted
              uni.ex_name = uni.ex_name1
              // delete uni.ex_name1
              axios.post(`${this.BASE_URL}/admins/userId/academicUnits`,
                {
                  university: uni,
                  college: col,
                  faculty: fac,
                  department: dep
                }
              ).then((response) => {
                this.notifyUser('success', 'Επιτυχία', 'Η αποθήκευση ολοκληρώθηκε επιτυχώς')
                this.initializeUniversity()
                this.initializeCollege()
                this.initializeFaculty()
                this.initializeDepartment()
                this.countryInsertedChanged()
                this.country = {id: '', name: '', nameInserted: '', ex_name: '', states_exist: 0, short_name: ''}
                this.collegeSelect = {id: null, name: ''}
                this.facultySelect = {id: null, name: ''}
                this.departmentSelect = {id: null, name: ''}
                this.disableFaculty = true
                this.disableDepartment = true
                this.disableCollege = true
                this.disableUniversity = true
              }).catch((err) => {
                this.notifyUser('error', 'Αποτυχία', 'Παρουσιάστηκε σφάλμα κατά την αποθήκευση')
                this.backendError(err)
              })
            }
          }).catch((err) => {
            console.log(err)
            this.$message({
              type: 'info',
              message: 'Η αποθήκευση ματαιώθηκε'
            })
          })
        }
      } else {
        if (this.checkboxΙnstitutions[0] === 'Συνεδρία') {
          this.savingMeeting = true
          axios.put(`${this.BASE_URL}/admins/userId/meetings/${this.meeting.id}`,
            {
              meeting: {
                meeting_no: this.meeting.nameInserted,
                meeting_date: this.meeting.meeting_date,
                ds_epitropi: this.meeting.ds_epitropi,
                resp_id: this.meeting.resp_id
              }
            }
          ).then((response) => {
            this.notifyUser('success', 'Επιτυχία', 'Η αποθήκευση ολοκληρώθηκε επιτυχώς')
            this.savingMeeting = false
            this.getMeetings()
            this.meeting = {meeting_no: '', id: '', nameInserted: '', meeting_date: '', ds_epitropi: 'D', resp_id: ''}
          }).catch((err) => {
            this.notifyUser('error', 'Αποτυχία', 'Παρουσιάστηκε σφάλμα κατά την αποθήκευση')
            this.savingMeeting = false
            this.backendError(err)
          })
        } else if (this.checkboxΙnstitutions[0] === 'Χώρα') {
          // PUT to change existing country
          let tempCountry = {...this.country}
          tempCountry.name = tempCountry.nameInserted
          tempCountry.states_exist = this.states_exist ? 1 : 0
          delete tempCountry.id
          delete tempCountry.nameInserted
          this.savingCountry = true
          axios.put(
            `${this.BASE_URL}/admins/userId/countries/${this.country.id}`,
            {country: tempCountry}
          ).then((response) => {
            this.notifyUser('success', 'Επιτυχία', 'Η αποθήκευση ολοκληρώθηκε επιτυχώς')
            this.savingCountry = false
            this.getCountries()
          }).catch((err) => {
            this.savingCountry = false
            this.notifyUser('error', 'Αποτυχία', 'Παρουσιάστηκε σφάλμα κατά την αποθήκευση')
            this.backendError(err)
          })
        } else if (this.university.name === 'other' || this.college.name === 'other' ||
          this.faculty.name === 'other' || this.department.name === 'other') {
          this.$notify.warning({
            title: 'Προειδοποίηση',
            message: 'Δεν μπορείτε να προσθέσετε αν δεν επιλέξετε Προσθήκη και όχι Τροποποίηση',
            offset: 300
          })
        } else if ((this.isEmptyValue(this.university.name) && this.checkboxΙnstitutions[0] === 'Πανεπιστήμιο') ||
          (this.isEmptyValue(this.college.name) && this.checkboxΙnstitutions[0] === 'Κολλέγιο') ||
          (this.isEmptyValue(this.faculty.name) && this.checkboxΙnstitutions[0] === 'Σχολή') ||
          (this.isEmptyValue(this.department.name) && this.checkboxΙnstitutions[0] === 'Τμήμα')) {
          this.$notify.warning({
            title: 'Προειδοποίηση',
            message: 'Δεν έχετε επιλέξει τη δομή προς τροποποίηση.',
            offset: 300
          })
        } else if ((this.college.name === 'Οι σπουδές δεν έγιναν σε κολλέγιο' && this.checkboxΙnstitutions[0] === 'Κολλέγιο') ||
          (this.faculty.name === 'Οι σπουδές δεν έγιναν σε σχολή' && this.checkboxΙnstitutions[0] === 'Σχολή') ||
          (this.department.name === 'Οι σπουδές δεν έγιναν σε τμήμα' && this.checkboxΙnstitutions[0] === 'Τμήμα')) {
          this.$notify.warning({
            title: 'Προειδοποίηση',
            message: 'Δεν μπορείτε να τροποποιήσετε αυτήν την επιλογή',
            offset: 300
          })
        } else {
          confirmMessage = this.addConfirmMessage()
          this.$confirm(confirmMessage.message, 'Προειδοποίηση', {
            confirmButtonText: 'Αποθήκευση',
            cancelButtonText: 'Άκυρο',
            type: 'warning'
          }).then(() => {
            if (!confirmMessage.missingRequired) {
              let putUnit = {}
              let putUrl = ''
              if (this.checkboxΙnstitutions[0] === 'Πανεπιστήμιο') {
                let uni = {...this.university}
                uni.name = uni.nameInserted
                delete uni.nameInserted
                uni.states = uni.state.id
                delete uni.state
                uni.cities_id = uni.city.id
                delete uni.city
                uni.meetings_id = uni.meeting.id
                delete uni.meeting
                // uni.ex_name = uni.ex_name1
                // delete uni.ex_name
                putUnit = { university: uni }
                putUrl = 'uni'
              } else if (this.checkboxΙnstitutions[0] === 'Κολλέγιο') {
                let col = {...this.college}
                col.name = col.nameInserted
                delete col.nameInserted
                col.meetings_id = col.meeting.id
                delete col.meeting
                putUnit = { college: col }
                putUrl = 'col'
              } else if (this.checkboxΙnstitutions[0] === 'Σχολή') {
                let fac = {...this.faculty}
                fac.name = fac.nameInserted
                delete fac.nameInserted
                fac.meetings_id = fac.meeting.id
                delete fac.meeting
                putUnit = { faculty: fac }
                putUrl = 'fac'
              } else if (this.checkboxΙnstitutions[0] === 'Τμήμα') {
                let dep = {...this.department}
                dep.name = dep.nameInserted
                delete dep.nameInserted
                dep.meetings_id = dep.meeting.id
                delete dep.meeting
                putUrl = 'dep'
                putUnit = { department: dep }
              }
              axios.put(
                `${this.BASE_URL}/admins/userId/${putUrl}`,
                putUnit
              ).then((response) => {
                this.notifyUser('success', 'Επιτυχία', 'Η τροποποίηση ολοκληρώθηκε επιτυχώς')
                this.initializeUniversity()
                this.initializeCollege()
                this.initializeFaculty()
                this.initializeDepartment()
                this.countryInsertedChanged()
                this.country = {id: '', name: '', nameInserted: '', ex_name: '', states_exist: 0, short_name: ''}
                this.collegeSelect = {id: null, name: ''}
                this.facultySelect = {id: null, name: ''}
                this.departmentSelect = {id: null, name: ''}
                this.disableFaculty = true
                this.disableDepartment = true
                this.disableCollege = true
                this.disableUniversity = true
              }).catch((err) => {
                this.notifyUser('error', 'Αποτυχία', 'Παρουσιάστηκε σφάλμα κατά την τροποποίηση')
                this.backendError(err)
              })
            }
          }).catch(() => {
            this.$message({
              type: 'info',
              message: 'Η τροποποίηση ματαιώθηκε'
            })
          })
        }
      }
    },
    isEmptyValue (val) {
      return !(val !== null && val !== undefined && val !== '')
    },
    notifyUser (type, title, msg) {
      if (type === 'success') {
        this.$notify.success({
          title: title,
          message: msg
        })
      } else {
        this.$notify.error({
          title: title,
          message: msg
        })
      }
    },
    addOrModifyChanged () {
      this.addMeeting = false
      this.manageStates = false
      this.state = { id: null, name: '', countries_id: null, abbrv: null }
      this.manageCities = false
      this.city = { id: null, name: '', countries_id: null, state: {name: '', id: ''} }
      this.initializeColFacDep()
      this.initializeUniversity()
      this.initializeCollege()
      this.initializeFaculty()
      this.initializeDepartment()
      this.checkboxΙnstitutions = []
      this.country = {id: '', name: '', nameInserted: '', ex_name: '', states_exist: 0, short_name: ''}
      this.university.name = ''
      this.university.id = null
      this.university.nameInserted = ''
      this.universitySelect = {name: '', id: null}
      this.collegeSelect = {name: '', id: null}
      this.facultySelect = {name: '', id: null}
      this.departmentSelect = {name: '', id: null}
      this.disableUniversity = true
      this.disableCollege = true
      this.disableFaculty = true
      this.disableDepartment = true
      if (this.addOrModify) {
        this.showAll = {country: true, university: true, college: true, faculty: true, department: true}
      } else {
        this.showAll = {country: false, university: false, college: false, faculty: false, department: false}
      }
    },
    collegeDepartmentInsertedChanged (ev) {
      // this.department.nameInserted = ev
    },
    collegeFacultyInsertedChanged () {
      // this.college.departments = []
      // this.fieldChanged()
    },
    departmentInsertedChanged () {
    },
    facultyInsertedChanged () {
      // this.college.departments = []
    },
    collegeInsertedChanged () {
      // this.faculties = []
      // this.departments = []
    },
    countryInsertedChanged () {
      this.initializeColFacDep()
      this.colleges = []
      this.faculties = []
      this.departments = []
      this.activeFaculties = []
      this.activeDepartments = []
      this.collegeFaculties = []
      this.colFacDepartments = []
    },
    universityInsertedChanged () {
      // this.initializeColFacDep()
      // this.colleges = []
      // this.faculties = []
      // this.departments = []
      // this.collegeFaculties = []
      // this.colFacDepartments = []
    },
    initializeColFacDep () {
      this.faculty.id = null
      this.faculty.name = null
      this.faculty.nameInserted = null
      this.department.id = null
      this.department.name = null
      this.department.nameInserted = null
      this.college.id = null
      this.college.name = null
      this.college.nameInserted = null
    },
    citySelected (city) {
      this.university.cities_id = city.id
    },
    countrySelected (country, val) {
      this.manageStates = false
      this.state = { id: null, name: '', countries_id: null, abbrv: null }
      this.manageCities = false
      this.city = { id: null, name: '', countries_id: null, state: {name: '', id: ''} }
      this.disableUniversity = false
      // Για την τροποποίηση
      // Φέρνουμε την χώρα μόνο αν είναι να την αλλάξουμε
      if (!this.addOrModify && this.checkboxΙnstitutions[0] === 'Χώρα') {
        this.gettingCountry = true
        axios.get(`${config.BASE_URL}/admins/userid/countries/${country.id}`)
          .then((response) => {
            this.gettingCountry = false
            this.country = response.data.data
            this.$set(this.country, 'nameInserted', response.data.data.name)
            // this.getCities()
          }).catch(err => {
            this.gettingCountry = false
            this.backendError(err)
          })
      // Για την προσθήκη και τροποποίηση των υπολοίπων φέρε πανεπ.
      } else {
        this.university.id = null
        this.university.name = null
        this.university.nameInserted = ''
        this.initializeUniversity()
        this.initializeCollege()
        this.initializeFaculty()
        this.initializeDepartment()
        this.initializeColFacDep()
        this.disableCollege = true
        this.disableFaculty = true
        this.disableDepartment = true
        // Αν επιλέξει υπάρχουσα χώρα
        if (country.name !== 'Άλλο') {
          if (this.addOrModify) {
            this.showAll = {country: true, university: true, college: true, faculty: true, department: true}
          }
          if (country) {
            this.city = {id: null, name: ''}
            // Φέρε τις πόλεις μιας χώρας (προσθήκη και τροποποίηση)
            this.getCities().then(response => { this.cities = response.data.data })
            this.gettingUniversities = true
            this.universities = []
            // Φέρε τα Πανεπιστήμια μιας χώρας (προσθήκη-τροποποίηση εκτός αν τροποποιούμε χώρα)
            axios.get(`${config.BASE_URL}/countries/${country.id}/universities`)
              .then((response) => {
                this.universities = response.data.data.filter(u => u.is_new_institute === 0)
                this.gettingUniversities = false
              }).catch(err => {
                this.gettingUniversities = false
                this.backendError(err)
                this.colleges = []
                this.colFacDept = []
                this.collegeFaculties = []
                this.colFacDepartments = []
                this.faculties = []
                this.departments = []
              })
          } else {
            this.disableUniversity = true
            this.disableCollege = true
            this.disableFaculty = true
            this.disableDepartment = true
            this.universities = []
            this.colleges = []
            this.faculties = []
            this.departments = []
          }
        } else {
          this.showAll = {country: true, university: false, college: false, faculty: false, department: false}
          // this.country = {id: '', name: 'Αλλο', nameInserted: '', ex_name: '', states_exist: 0, short_name: ''}
        }
      }
    },
    getFacultiesCollegesDepartments (country, university) {
      axios.get(`${config.BASE_URL}/countries/${country}/universities/${university}`)
        .then((response) => {
          // all {colleges:[] {faculties:[] {departments:[]}}, Faculties:[] {departments:[]}} for university
          this.colFacDept = response.data.data
          // get the university colleges:[{faculties:[{departments[]},...]},...]
          this.colleges = this.colFacDept.colleges
          // get the university faculties: [{departments[]},...]
          this.faculties = this.colFacDept.faculties
          this.collegeFaculties = []
          this.colFacDepartments = []
          this.departments = []
        })
    },
    universitySelected (university) {
      this.initializeColFacDep()
      this.initializeUniversity()
      this.university.nameInserted = ''
      this.disableFaculty = true
      this.disableDepartment = true
      if (university !== 'other') {
        this.collegeSelect = {id: null, name: ''}
        this.facultySelect = {id: null, name: ''}
        this.departmentSelect = {id: null, name: ''}
        this.university.name = university.name
        this.university.id = university.id
        this.universitySelect = {name: university.name, id: university.id}
        // If modify call for selected University
        if (!this.addOrModify) {
          this.gettingUniversity = true
          axios.get(`${config.BASE_URL}/universities/${university.id}`)
            .then((response) => {
              this.university = response.data.data[0]
              this.$set(this.university, 'nameInserted', response.data.data[0].name)
              this.gettingUniversity = false
            }).catch(err => {
              this.backendError(err)
              this.gettingUniversity = false
            })
        }
        this.getFacultiesCollegesDepartments(this.country.id, university.id)
      } else {
        this.getStates()
        this.university.name = university
        this.university.id = null
        this.universitySelect = university
        if (!this.addOrModify) {
          this.$notify.warning({
            title: 'Προειδοποίηση',
            message: 'Για να εισάγετε νέο Πανεπιστήμιο επιλέξτε Προσθήκη και όχι Τροποποίηση',
            offset: 300
          })
        }
        this.college.id = null
        this.college.name = 'Οι σπουδές δεν έγιναν σε κολλέγιο'
        this.collegeSelect = {id: null, name: 'Οι σπουδές δεν έγιναν σε κολλέγιο'}
        this.faculty.id = null
        this.faculty.name = 'Οι σπουδές δεν έγιναν σε σχολή'
        this.facultySelect = {id: null, name: 'Οι σπουδές δεν έγιναν σε σχολή'}
        this.department.id = null
        this.department.name = 'Οι σπουδές δεν έγιναν σε τμήμα'
        this.departmentSelect = {id: null, name: 'Οι σπουδές δεν έγιναν σε τμήμα'}
        this.colleges = [{id: null, name: 'Οι σπουδές δεν έγιναν σε κολλέγιο'}]
        this.activeFaculties = [{id: null, name: 'Οι σπουδές δεν έγιναν σε σχολή'}]
        this.activeDepartments = [{id: null, name: 'Οι σπουδές δεν έγιναν σε τμήμα'}]
        this.disableFaculty = false
        this.disableDepartment = false
      }
      this.disableCollege = false
      this.disableSave = false
    },
    collegeSelected (college) {
      this.college.nameInserted = null
      this.initializeCollege()
      // Αν το Πανεπιστήμιο είναι other έχει τις επιλογές μόνο other και 'οι σπουδές δεν...'
      // if (this.university.name !== 'other') {
      if (college && college !== 'other') {
        this.facultySelect = {id: null, name: ''}
        this.departmentSelect = {id: null, name: ''}
        this.college.id = college.id
        this.college.name = college.name
        this.collegeSelect = {name: college.name, id: college.id}
        if (college === 'Οι σπουδές δεν έγιναν σε κολλέγιο') {
          this.college.id = null
          this.college.name = college
          this.activeFaculties = this.faculties
          if (!this.addOrModify && this.checkboxΙnstitutions[0] === 'Κολλέγιο') {
            this.$notify.warning({
              title: 'Προειδοποίηση',
              message: 'Δεν μπορείτε να τροποποιήσετε αυτό το Κολλέγιο',
              offset: 300
            })
          }
        } else {
          this.activeFaculties = this.collegeFaculties
          this.activeDepartments = this.activeFaculties.departments
          if (!this.addOrModify) {
            this.gettingCollege = true
            axios.get(`${config.BASE_URL}/colleges/${college.id}`)
              .then((response) => {
                this.college = response.data.data[0]
                if (!this.addOrModify) {
                  this.$set(this.college, 'nameInserted', response.data.data[0].name)
                }
                this.gettingCollege = false
              }).catch(err => {
                this.backendError(err)
                this.gettingCollege = false
              })
          }
          this.collegeFaculties = this.colleges
            ? this.colleges.find(col => col.id === college.id).faculties
            : [{ id: 0, name: 'δεν βρέθηκε' }]
          this.activeFaculties = this.collegeFaculties
        }
      } else {
        this.college.id = null
        this.college.name = college
        this.collegeSelect = college
        if (!this.addOrModify) {
          this.$notify.warning({
            title: 'Προειδοποίηση',
            message: 'Για να εισάγετε νέο Πανεπιστήμιο επιλέξτε Προσθήκη και όχι Τροποποίηση',
            offset: 300
          })
        }
        this.disableFaculty = false
        this.disableDepartment = false
        this.departmentSelect = {name: 'Οι σπουδές δεν έγιναν σε τμήμα', id: null}
        this.faculty.id = null
        this.faculty.name = 'Οι σπουδές δεν έγιναν σε σχολή'
        this.facultySelect = {id: null, name: 'Οι σπουδές δεν έγιναν σε σχολή'}
        this.department.id = null
        this.department.name = 'Οι σπουδές δεν έγιναν σε τμήμα'
        this.activeFaculties = [{id: null, name: 'Οι σπουδές δεν έγιναν σε σχολή'}]
        this.activeDepartments = [{id: null, name: 'Οι σπουδές δεν έγιναν σε τμήμα'}]
      }
      // }
      this.disableFaculty = false
    },
    facultySelected (faculty) {
      this.faculty.nameInserted = null
      this.initializeFaculty()
      // Αν δεν είναι άλλο
      if (faculty !== 'other') {
        this.departmentSelect = {id: null, name: ''}
        // Αν είναι 'δεν εγιναν..' δώσε κατάλληλο όνομα και id
        if (faculty === 'Οι σπουδές δεν έγιναν σε σχολή') {
          this.faculty.name = faculty
          this.faculty.id = null
          this.facultySelect = faculty
        } else {
          this.faculty.name = faculty.name
          this.faculty.id = faculty.id
          this.facultySelect = faculty
          // Αν είναι τροποποίηση φέρε τα στοιχεία της Σχολής
          if (!this.addOrModify) {
            this.gettingFaculty = true
            axios.get(`${config.BASE_URL}/faculties/${faculty.id}`)
              .then((response) => {
                this.faculty = response.data.data[0]
                if (!this.addOrModiFdepartmentfy) {
                  this.$set(this.faculty, 'nameInserted', response.data.data[0].name)
                }
                this.gettingFaculty = false
              }).catch(err => {
                this.backendError(err)
                this.gettingFaculty = false
              })
          }
        }
        // Επιλογή Τμημάτων που θα εμφανίσει στο dropdown ανάλογα με το αν ανήκει σε κάποιο κολλέγιο ή μόνο στην σχολή
        if (!this.isEmptyValue(this.college.name)) {
          let facId = faculty === 'Οι σπουδές δεν έγιναν σε σχολή' ? null : faculty.id
          if (this.college.name !== 'Οι σπουδές δεν έγιναν σε κολλέγιο') {
            this.colFacDepartments = this.collegeFaculties
              ? this.collegeFaculties.find(fac => fac.id === facId).departments
              : [{id: 0, name: 'δεν βρέθηκε'}]
            this.activeDepartments = this.colFacDepartments
          } else {
            if (faculty === 'Οι σπουδές δεν έγιναν σε σχολή') {
              this.activeDepartments = []
            } else {
              this.activeDepartments = this.faculties.find(fac => fac.id === facId).departments
            }
          }
        }
        // Αν είναι 'other' αρχικοποίησε το τμήμα σε 'δεν έγιναν ...'
      } else {
        this.faculty.name = faculty
        this.faculty.id = null
        this.facultySelect = faculty
        if (!this.addOrModify) {
          this.$notify.warning({
            title: 'Προειδοποίηση',
            message: 'Για να εισάγετε νέα Σχολή επιλέξτε Προσθήκη και όχι Τροποποίηση',
            offset: 300
          })
        }
        this.department.id = null
        this.department.name = 'Οι σπουδές δεν έγιναν σε τμήμα'
        this.departmentSelect = {name: 'Οι σπουδές δεν έγιναν σε τμήμα', id: null}
        this.activeDepartments = [{id: null, name: 'Οι σπουδές δεν έγιναν σε τμήμα'}]
      }
      // }
      this.disableDepartment = false
    },
    departmentSelected (department) {
      this.department.nameInserted = ''
      this.initializeDepartment()
      // Αν δεν είναι 'Άλλο'
      if (department !== 'other') {
        if (department !== 'Οι σπουδές δεν έγιναν σε τμήμα') {
          this.department.id = department.id
          this.department.name = department.name
          this.departmentSelect = department
          if (!this.addOrModify) {
            this.gettingDepartment = true
            axios.get(`${config.BASE_URL}/departments/${department.id}`)
              .then((response) => {
                this.department = response.data.data[0]
                if (!this.addOrModify) {
                  this.$set(this.department, 'nameInserted', response.data.data[0].name)
                }
                this.gettingDepartment = false
              }).catch(err => {
                this.backendError(err)
                this.gettingDepartment = false
              })
          }
        } else {
          this.department.id = null
          this.department.name = department
          this.departmentSelect = department
          if (!this.addOrModify && this.checkboxΙnstitutions[0] === 'Σχολή') {
            this.$notify.warning({
              title: 'Προειδοποίηση',
              message: 'Δεν μπορείτε να τροποποιήσετε αυτή τη Σχολή',
              offset: 300
            })
          }
        }
      } else {
        this.department.id = null
        this.department.name = department
        this.departmentSelect = department
        if (!this.addOrModify) {
          this.$notify.warning({
            title: 'Προειδοποίηση',
            message: 'Για να εισάγετε νέα Σχολή επιλέξτε Προσθήκη και όχι Τροποποίηση',
            offset: 300
          })
        }
      }
      // }
    }
  },
  computed: {
    institutions () {
      return this.activeRole !== 'RegistryAdmin'
        ? ['Χώρα', 'Πανεπιστήμιο', 'Κολλέγιο', 'Σχολή', 'Τμήμα', 'Συνεδρία']
        : ['Πανεπιστήμιο', 'Συνεδρία']
    },
    showNotDepartment () {
      return this.activeDepartments
        ? !this.activeDepartments.find(col => col.name === 'Οι σπουδές δεν έγιναν σε τμήμα')
        : false
    },
    showNotCollege () {
      return this.colleges
        ? !this.colleges.find(col => col.name === 'Οι σπουδές δεν έγιναν σε κολλέγιο')
        : false
    },
    showNotFaculty () {
      return this.activeFaculties
        ? !this.activeFaculties.find(col => col.name === 'Οι σπουδές δεν έγιναν σε σχολή')
        : false
    },
    disableDelete () {
      return this.addOrModify
    },
    saveButtonText () {
      return this.addOrModify ? 'Εισαγωγή' : 'Τροποποίηση'
    },
    ...mapGetters(['activeRole']),
    ...mapState([
      'searchVisible',
      'searchForeignVisible',
      'internalUsers',
      'BASE_URL',
      'countries',
      'meetings',
      'academicAreas',
      'countries',
      'gettingCountries'
    ])
  },
  watch: {
    country: {
      handler: function (newVal, oldVal) {
        this.states_exist = !!newVal.states_exist
      },
      deep: true
    }
  }
}
</script>

<style lang="scss">
.commentText {
  width: 320px;
}
.el-select {
  &.big {
    width: 440px;
  }
  &.biggest {
    width: 1100px;
  }
  &.countries {
    width: 440px;
  }
}
.el-input {
  &.big {
    width: 440px;
  }
  &.biggest {
    width: 540px;
  }
}
.list-group {
  min-height: 20px;
}

.list-group-item {
  background-color: #7fa3bb;
  &:hover {
    background-color: #4d7590;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/roleSpecific/ManageDb.vue